module.exports = __webpack_public_path__ + "img/icon-config-evolutive.4aab2850.svg";